import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ankabnk96: FaireProductEntity = {
  token: "p_3ankabnk96",
  type: "product",
  name: "Dainty Block Print Blue Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6a143269b56ef0172abb998500c215e15df2c10aa413afa635dcc62901772cfe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f8a00821052c548e6bf4a2e7e917c42bf0ff58fd3cf9110c2ea22dd7f15723e3.jpeg",
    "https://cdn.faire.com/fastly/3f8c7d179e0b02c8bc4ecaf0e766f7205a50bd411e1ea990ce37e91be70a7f92.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:39.798Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
